module.exports = __webpack_public_path__ + "img/error.e0a20774.svg";